<div class="container-fluid pb-1 mx-auto" style="background-color: #567ba0;">
    <div class="mx-auto" style="width: 90%;">
        <p class="mb-0">
            <a class="btn btn-xs text-light shadow-none align-middle px-0" (click)="closeModal()">
            <img src="./assets/images/arrow-left.svg" width="18px">
            Volver</a>
        </p>
        <h2 class="text-light mb-0">Nueva solicitud de mantenimiento</h2>
    </div>
  </div>
  <form [formGroup]="requestForm">
        <div class="row my-3 mx-auto" style="width: 90%;">
            <div class="col">
                <div class="row mx-0 mb-3" style="justify-content: space-between;">
                    <div class="col-12 mx-auto">
                        <div class="row mb-2">
                            <div class="col pe-1 px-0">
                                <label mdbLabel>Fecha: {{dateNow}}</label>
                            </div>
                            <div class="col-auto">
                                <label mdbLabel>Solicitante: {{requesterUser}}</label>
                            </div>
                        </div>
                        <div class="row mb-2 position-relative">
                            <mdb-form-control class="custom-shadow">
                                <mdb-select mdbValidate placeholder="Linea" [filter]="true" (valueChange)="buildProductionEquipment($event)" formControlName="productionLineSelected">
                                    <mdb-option [value]="" disabled>Seleccione Linea</mdb-option>
                                    <mdb-option *ngFor="let item of productionLine" [value]="item.ID">
                                        {{ item.NAME }}
                                    </mdb-option>
                                </mdb-select>
                                <label mdbLabel class="form-label">Linea</label>
                            </mdb-form-control>
                            <div *ngIf="requestForm?.get('productionLineSelected')?.touched && requestForm?.get('productionLineSelected')?.errors?.['required']" class="floating-alert">
                                <span class="error-icon me-2">⚠️</span>Seleccione una Linea
                            </div>
                        </div>
                        <div class="row mb-2">
                            <mdb-form-control class="custom-shadow">
                                <mdb-select placeholder="Equipo" [filter]="true" formControlName="productionEquipmentSelected">
                                    <mdb-option [value]="" disabled>Seleccione Equipo</mdb-option>
                                    <mdb-option *ngFor="let item of productionEquipment" [value]="item.ID">
                                        {{ item.NAME }}
                                    </mdb-option>
                                </mdb-select>
                                <label mdbLabel class="form-label">Equipo</label>
                            </mdb-form-control>
                            <div *ngIf="requestForm?.get('productionEquipmentSelected')?.touched && requestForm?.get('productionEquipmentSelected')?.errors?.['required']" class="floating-alert">
                                <span class="error-icon me-2">⚠️</span>Seleccione un Equipo
                            </div>
                        </div>
                        <div class="row mb-2">
                            <mdb-form-control class="custom-shadow">
                                <mdb-select placeholder="Especialidad" [filter]="true" formControlName="productionSpecialitySelected">
                                    <mdb-option [value]="" disabled>Seleccione Especialidad</mdb-option>
                                    <mdb-option *ngFor="let item of productionSpeciality" [value]="item.ID">
                                        {{ item.NAME }}
                                    </mdb-option>
                                </mdb-select>
                                <label mdbLabel class="form-label">Especialidad</label>
                            </mdb-form-control>
                            <div *ngIf="requestForm?.get('productionSpecialitySelected')?.touched && requestForm?.get('productionSpecialitySelected')?.errors?.['required']" class="floating-alert">
                                <span class="error-icon me-2">⚠️</span>Seleccione una Especialidad
                            </div>
                        </div>
                        <div class="row mb-2 position-relative">
                            <mdb-form-control class="custom-shadow">
                                <textarea mdbValidate mdbInput placeholder="Problema" formControlName="problem" rows="5" class="form-control"></textarea>
                                <label mdbLabel class="form-label">Problema</label>
                            </mdb-form-control>
                            <div *ngIf="requestForm?.get('problem')?.touched && requestForm?.get('problem')?.errors?.['required']" class="floating-alert">
                                <span class="error-icon me-2">⚠️</span>Ingrese un problema
                            </div>
                        </div>
                        <div>
                            <div class="row table-editor_input-wrapper">
                                <div class="col-md-12">
                                    <mdb-file-upload 
                                        #fileUpload 
                                        formControlName="photo" 
                                        [defaultPreview]="'https://cdn.pixabay.com/photo/2016/01/03/00/43/upload-1118929_1280.png'" 
                                        [removeBtn]="'Eliminar'"
                                        [defaultMsg]="'Seleccione Imagen'"
                                        [previewMsg]="'Arrastre o haga click para seleccionar otro archivo'" 
                                        [removeBtnDisabled]="false"
                                        (fileAdded)="onFileAdded($event)"
                                        (fileRemoved)="onFileRemoved()">
                                    </mdb-file-upload>
                                    <div *ngIf="requestForm?.get('photo')?.touched && requestForm?.get('photo')?.errors?.['required']" class="floating-alert">
                                        <span class="error-icon me-2">⚠️</span>Seleccione una imagen
                                    </div>
                                </div>
                            </div>
                            <div class="row px-0 pt-1">
                                <button type="button" class="shadow-0 btn btn-md btn-success" (click)="createRequestBinnacle()">
                                    CREAR SOLICITUD
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
  </form>

  <mdb-loading [show]="loadingFull" [fullscreen]="true">
      <div class="loading-spinner">
          <div class="spinner-border loading-icon" role="status"></div>
          <span class="loading-text">Cargando datos...</span>
      </div>
  </mdb-loading>